(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94b4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94b4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fw0Zn", function(module, exports) {

$parcel$export(module.exports, "get_info", function () { return $b4ba9c8e7a201193$export$3697bcf53517e83c; });

var $e96f1 = parcelRequire("e96f1");

var $h9BHh = parcelRequire("h9BHh");

var $5eYZm = parcelRequire("5eYZm");
async function $b4ba9c8e7a201193$export$3697bcf53517e83c() {
    let response = await (0, $h9BHh.get_info_cached)();
    if (typeof response !== 'object') {
        console.error('Geolocation IP Detection Error: Record should be an object, not a ' + typeof response, response);
        response = {
            'extra': {
                'error': response || 'Network error, look at the original server response ...'
            }
        };
    }
    const record = new (0, $e96f1.default)(response, (0, $5eYZm.options).default_locales);
    return record;
}

});
parcelRegister("e96f1", function(module, exports) {

$parcel$export(module.exports, "camelToUnderscore", function () { return $a4c6bf567c1b63c8$export$13bc6c4afe8cd6ab; });
$parcel$export(module.exports, "default", function () { return $a4c6bf567c1b63c8$export$2e2bcd8739ae039; });

var $8WYat = parcelRequire("8WYat");

var $aUbCw = parcelRequire("aUbCw");
const $a4c6bf567c1b63c8$var$_get_localized = function(ret, locales) {
    if (typeof ret === 'object' && ret !== null) {
        if (typeof ret.names === 'object' && typeof locales === 'object') for(let i = 0; i < locales.length; i++){
            let locale = locales[i];
            if (ret.names[locale]) return ret.names[locale];
        }
        if (ret.name) return ret.name;
        return '';
    }
    return ret;
};
const $a4c6bf567c1b63c8$export$13bc6c4afe8cd6ab = function(key) {
    key = key.split('.').map((x)=>{
        if (typeof x !== 'string' || typeof x[0] !== 'string') return '';
        x = x[0].toLowerCase() + x.slice(1); // to allow "MostSpecificSubdivision"
        x = x.replace(/([A-Z])/g, "_$1").toLowerCase();
        return x;
    }).join('.');
    return key;
};
class $a4c6bf567c1b63c8$var$Record {
    get(prop, default_value) {
        return this.get_with_locales(prop, null, default_value);
    }
    get_raw(prop) {
        prop = $a4c6bf567c1b63c8$export$13bc6c4afe8cd6ab(prop);
        return (0, (/*@__PURE__*/$parcel$interopDefault($aUbCw)))(this.data, prop, null);
    }
    has_property(prop) {
        const ret = this._lookup_with_locales(prop, this.default_locales, null);
        return ret !== null;
    }
    _lookup_with_locales(prop, locales, default_value = '') {
        locales = this._process_locales(locales);
        // Treat pseudo-property 'name' as if it never existed
        if (prop.substr(-5) === '.name') prop = prop.substr(0, prop.length - 5);
        let ret = this.get_raw(prop);
        // Localize property, if possible
        ret = $a4c6bf567c1b63c8$var$_get_localized(ret, locales);
        if (ret === null || ret === '') ret = default_value;
        return ret;
    }
    _process_locales(locales) {
        if (typeof locales === 'string') locales = [
            locales
        ];
        if (!Array.isArray(locales) || locales.length === 0) locales = this.default_locales;
        return locales;
    }
    get_with_locales(prop, locales, default_value) {
        const ret = this._lookup_with_locales(prop, locales, default_value);
        if (typeof ret === 'object') console.warn('Geolocation IP Detection: The property "' + prop + '" is of type "' + typeof ret + '", should be string or similar', ret);
        if (typeof ret === 'undefined') {
            console.warn('Geolocation IP Detection: The property "' + prop + '" is not defined, please check spelling or maybe you need a different data source', {
                data: this.data
            });
            return '';
        }
        return ret;
    }
    get_country_iso() {
        let country = this.get('country.iso_code');
        if (country) country = country.substr(0, 2).toLowerCase();
        return country;
    }
    /**
     * Check if there is information available for this IP
     * @returns boolean 
     */ is_empty() {
        return this.get('is_empty', false);
    }
    /**
     * Get error message, if any
     * @return string Error Message
     */ error() {
        return this.get_raw('extra.error') || '';
    }
    /**
     * Get the raw data of this object
     * @returns object
     */ serialize() {
        return this.data;
    }
    constructor(data, default_locales){
        (0, $8WYat._)(this, "data", {});
        (0, $8WYat._)(this, "default_locales", []);
        this.data = data || {
            is_empty: true
        };
        this.default_locales = [
            'en'
        ];
        this.default_locales = this._process_locales(default_locales);
    }
}
var $a4c6bf567c1b63c8$export$2e2bcd8739ae039 = $a4c6bf567c1b63c8$var$Record;

});
parcelRegister("8WYat", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $68426998e3b11619$export$1e71eb4bef00f6b0; });
function $68426998e3b11619$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("aUbCw", function(module, exports) {
module.exports = $72e224a45f2258bd$var$get;
/*
  const obj = {a: {aa: {aaa: 2}}, b: 4};

  get(obj, 'a.aa.aaa'); // 2
  get(obj, ['a', 'aa', 'aaa']); // 2

  get(obj, 'b.bb.bbb'); // undefined
  get(obj, ['b', 'bb', 'bbb']); // undefined

  get(obj.a, 'aa.aaa'); // 2
  get(obj.a, ['aa', 'aaa']); // 2

  get(obj.b, 'bb.bbb'); // undefined
  get(obj.b, ['bb', 'bbb']); // undefined

  get(obj.b, 'bb.bbb', 42); // 42
  get(obj.b, ['bb', 'bbb'], 42); // 42

  get(null, 'a'); // undefined
  get(undefined, ['a']); // undefined

  get(null, 'a', 42); // 42
  get(undefined, ['a'], 42); // 42

  const obj = {a: {}};
  const sym = Symbol();
  obj.a[sym] = 4;
  get(obj.a, sym); // 4
*/ function $72e224a45f2258bd$var$get(obj, propsArg, defaultValue) {
    if (!obj) return defaultValue;
    var props, prop;
    if (Array.isArray(propsArg)) props = propsArg.slice(0);
    if (typeof propsArg == 'string') props = propsArg.split('.');
    if (typeof propsArg == 'symbol') props = [
        propsArg
    ];
    if (!Array.isArray(props)) throw new Error('props arg must be an array, a string or a symbol');
    while(props.length){
        prop = props.shift();
        if (!obj) return defaultValue;
        obj = obj[prop];
        if (obj === undefined) return defaultValue;
    }
    return obj;
}

});


parcelRegister("h9BHh", function(module, exports) {

$parcel$export(module.exports, "get_info_cached", function () { return $c7d084c9c1bb0fef$export$fba94e0366f5a647; });

var $6XCbI = parcelRequire("6XCbI");

var $5eYZm = parcelRequire("5eYZm");

var $kXwF1 = parcelRequire("kXwF1");
let $c7d084c9c1bb0fef$var$ajaxPromise = null;
function $c7d084c9c1bb0fef$var$get_info_raw() {
    if (!$c7d084c9c1bb0fef$var$ajaxPromise) {
        // Do Ajax Request only once per page load
        const url = (0, $5eYZm.options).ajaxurl + '?action=geoip_detect2_get_info_from_current_ip';
        $c7d084c9c1bb0fef$var$ajaxPromise = (0, $6XCbI.makeJSONRequest)(url);
        $c7d084c9c1bb0fef$var$ajaxPromise.then((response)=>{
            var _response_extra;
            if (response === null || response === void 0 ? void 0 : (_response_extra = response.extra) === null || _response_extra === void 0 ? void 0 : _response_extra.error) console.error('Geolocation IP Detection Error: Server returned an error: ' + response.extra.error);
        });
    }
    return $c7d084c9c1bb0fef$var$ajaxPromise;
}
async function $c7d084c9c1bb0fef$export$fba94e0366f5a647() {
    let response = false;
    let storedResponse = false;
    // 1) Load Info from localstorage cookie cache, if possible
    if ((0, $5eYZm.options).cookie_name) {
        storedResponse = (0, $kXwF1.getRecordDataFromLocalStorage)();
        if (storedResponse === null || storedResponse === void 0 ? void 0 : storedResponse.extra /* this is the only property that is guarantueed */ ) {
            if (storedResponse.extra.override === true) console.info('Geolocation IP Detection: Using cached response (override)');
            else console.info('Geolocation IP Detection: Using cached response');
            return storedResponse;
        }
    }
    // 2) Get response
    try {
        response = await $c7d084c9c1bb0fef$var$get_info_raw();
    } catch (err) {
        console.log('Weird: Uncaught error...', err);
        response = err.responseJSON || err;
    }
    // 3) Save info to localstorage cookie cache
    if ((0, $5eYZm.options).cookie_name) {
        var _storedResponse_extra, _response_extra;
        // Check if Override has been set now
        storedResponse = (0, $kXwF1.getRecordDataFromLocalStorage)();
        if ((storedResponse === null || storedResponse === void 0 ? void 0 : (_storedResponse_extra = storedResponse.extra) === null || _storedResponse_extra === void 0 ? void 0 : _storedResponse_extra.override) === true) {
            console.info('Geolocation IP Detection: Using cached response (override)');
            return storedResponse;
        }
        let cache_duration = (0, $5eYZm.options).cookie_duration_in_days * 86400;
        if (response === null || response === void 0 ? void 0 : (_response_extra = response.extra) === null || _response_extra === void 0 ? void 0 : _response_extra.error) cache_duration = 60; // Cache errors only for 1 minute, then try again
        (0, $kXwF1.setRecordDataToLocalStorage)(response, cache_duration);
    }
    return response;
}

});
parcelRegister("6XCbI", function(module, exports) {

$parcel$export(module.exports, "makeJSONRequest", function () { return $5115e01e50a35b95$export$49434baf33460b11; });
// @see https://gomakethings.com/promise-based-xhr/
const $5115e01e50a35b95$export$699251e5611cc6db = function(url, method = 'GET') {
    // Create the XHR request
    var request = new XMLHttpRequest();
    // Return it as a Promise
    return new Promise(function(resolve, reject) {
        // Setup our listener to process compeleted requests
        request.onreadystatechange = function() {
            // Only run if the request is complete
            if (request.readyState !== 4) return;
            // Process the response
            if (request.status >= 200 && request.status < 300) // If successful
            resolve(request);
            else // If failed
            reject({
                status: request.status,
                statusText: request.statusText,
                request: request
            });
        };
        // Setup our HTTP request
        request.open(method || 'GET', url, true);
        // Send the request
        request.send();
    });
};
const $5115e01e50a35b95$export$8fe2eaa78e58529f = function(str) {
    try {
        return JSON.parse(str);
    } catch (e) {
        return $5115e01e50a35b95$var$createErrorObject('Invalid JSON: ' + str);
    }
};
function $5115e01e50a35b95$var$createErrorObject(errorMsg) {
    return {
        is_empty: true,
        extra: {
            error: errorMsg
        }
    };
}
const $5115e01e50a35b95$export$49434baf33460b11 = async function(url, method = 'GET') {
    try {
        const request = await $5115e01e50a35b95$export$699251e5611cc6db(url, method);
        if (!request.responseText || request.responseText === '0') return $5115e01e50a35b95$var$createErrorObject('Got an empty response from server. Did you enable AJAX in the options?');
        return $5115e01e50a35b95$export$8fe2eaa78e58529f(request.responseText);
    } catch (e) {
        return $5115e01e50a35b95$export$8fe2eaa78e58529f(e.request.responseText);
    }
};

});

parcelRegister("5eYZm", function(module, exports) {

$parcel$export(module.exports, "options", function () { return $3d0d91a3ea5987c5$export$41c562ebe57d11e2; });
var $3d0d91a3ea5987c5$var$_window_geoip_detect;
const $3d0d91a3ea5987c5$export$41c562ebe57d11e2 = (($3d0d91a3ea5987c5$var$_window_geoip_detect = window.geoip_detect) === null || $3d0d91a3ea5987c5$var$_window_geoip_detect === void 0 ? void 0 : $3d0d91a3ea5987c5$var$_window_geoip_detect.options) || {
    ajaxurl: "/wp-admin/admin-ajax.php",
    default_locales: [
        'en'
    ],
    cookie_duration_in_days: 7,
    cookie_name: 'geoip-detect-result',
    do_body_classes: false
};

});

parcelRegister("kXwF1", function(module, exports) {

$parcel$export(module.exports, "getRecordDataFromLocalStorage", function () { return $f422a70a3b9c8a83$export$c0c5a36406ccde34; });
$parcel$export(module.exports, "setRecordDataToLocalStorage", function () { return $f422a70a3b9c8a83$export$bfae0a1e3adc82ee; });
$parcel$export(module.exports, "getRecordDataLastEvaluated", function () { return $f422a70a3b9c8a83$export$88983ef80f4f72ac; });
$parcel$export(module.exports, "setRecordDataLastEvaluated", function () { return $f422a70a3b9c8a83$export$7bc079f12f70511d; });

var $de3ze = parcelRequire("de3ze");

var $5eYZm = parcelRequire("5eYZm");

var $e96f1 = parcelRequire("e96f1");
const $f422a70a3b9c8a83$export$c0c5a36406ccde34 = ()=>{
    return (0, $de3ze.getLocalStorage)((0, $5eYZm.options).cookie_name);
};
const $f422a70a3b9c8a83$export$bfae0a1e3adc82ee = (data, cache_duration)=>{
    (0, $de3ze.setLocalStorage)((0, $5eYZm.options).cookie_name, data, cache_duration);
};
let $f422a70a3b9c8a83$var$lastEvaluated = {};
const $f422a70a3b9c8a83$export$88983ef80f4f72ac = ()=>{
    return $f422a70a3b9c8a83$var$lastEvaluated;
};
const $f422a70a3b9c8a83$export$7bc079f12f70511d = ()=>{
    $f422a70a3b9c8a83$var$lastEvaluated = $f422a70a3b9c8a83$export$c0c5a36406ccde34();
};
const $f422a70a3b9c8a83$export$5bfd3f24e770e2a9 = ()=>{
    return new (0, $e96f1.default)($f422a70a3b9c8a83$export$c0c5a36406ccde34(), (0, $5eYZm.options).default_locales);
};

});
parcelRegister("de3ze", function(module, exports) {

$parcel$export(module.exports, "setLocalStorage", function () { return $9a0f598d59a61a3e$export$1f73f60bdb811cb1; });
$parcel$export(module.exports, "getLocalStorage", function () { return $9a0f598d59a61a3e$export$d3720feff416e85b; });
const $9a0f598d59a61a3e$export$1f73f60bdb811cb1 = function(variable, value, ttl_sec) {
    var data = {
        value: value,
        expires_at: new Date().getTime() + ttl_sec * 1000 / 1
    };
    localStorage.setItem(variable.toString(), JSON.stringify(data));
};
function $9a0f598d59a61a3e$export$720fb0373088e6ec(variable) {
    localStorage.removeItem(variable);
}
const $9a0f598d59a61a3e$export$d3720feff416e85b = function(variable) {
    let data = null;
    try {
        data = JSON.parse(localStorage.getItem(variable.toString()));
    } catch (e) {
        return null;
    }
    if (data !== null) {
        if (data.expires_at !== null && data.expires_at < new Date().getTime()) localStorage.removeItem(variable.toString());
        else return data.value;
    }
    return null;
};

});




/*
 Variant "Base": 
 
 A reduced JS file: 
 - No shortcodes, no body classes. 
*/ 
var $fw0Zn = parcelRequire("fw0Zn");
window.geoip_detect.get_info = (0, $fw0Zn.get_info);

})();
//# sourceMappingURL=frontend_base.js.map
